<h2 mat-dialog-title> <one-icon name="alert-circle"></one-icon> Oops, something went wrong, please message our Live Chat to help resolve</h2>
<div mat-dialog-content>
  <p>We are always adding features and updating the app and you may run into some bugs we missed in testing. We truly apologize for the inconvenience</p>
</div>
<div mat-dialog-actions>
  <button class="pf-button filled sm blue" (click)="onLiveChatClick($event)" cdkFocusInitial>Live Chat</button>
</div>
